'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function CountryListModel({goldApi}) {
	let countries;
	const obs = observable(this),
		load = async () => {
			if (!countries) {
				countries = await goldApi.exec('countries');
			}
			obs.dispatchEvent('countriesLoaded', countries);
		};
	Object.assign(this, {load});
};
